import axios from "axios";
import auth from "./auth";
const ajax = function (v) {
    const vueInstance = v;
    let loadingMsg = "";
    let noLoading = false;
    this.instance = axios.create({
        baseURL: window.VUE_APP_BASE_API,
        // withCredentials: true, // send cookies when cross-domain requests
        timeout: 20000,
        headers: {
            "X-Requested-With": "XMLHttpRequest",
            "content-Type": "application/json; charset=UTF-8",
            "Cache-Control": "no-cache",
            Platform: "1",
            Pragma: "no-cache",
        },
    });

    this.instance.interceptors.request.use(
        function (config) {
            if (!noLoading) {
                // vueInstance.$showLoading(loadingMsg);
            }
            // do something before request is sent
            const token = auth.getToken();
            if (token) {
                // let each request carry token
                // ['X-Token'] is a custom headers key
                // please modify it according to the actual situation
                config.headers["Authorization"] = "Bearer " + token;
            }
            // config.headers["lang"] = vueInstance.$lang.getLange();
            return config;
        },
        (error) => {
            // do something with request error
            // vueInstance.$hideLoading();
            return Promise.reject(error);
        }
    );

    this.instance.interceptors.response.use(
        function (response) {
            const res = response.data;
            if (response.config.responseType === "blob") {
                return Promise.resolve(res);
            } else if (res.Code == 0) {
                return Promise.resolve(res);
            } else {
                vueInstance.$showMsg(res);
                return Promise.reject(res);
            }
        },
        function (error) {
            console.log(error);
            try {
                if (error) {
                    if (error.response.code === "401") {
                        vueInstance
                            .$alert("请重新登录", "操作超时", {
                                confirmButtonText: "确定",
                                cancelButtonText: "取消",
                                type: "warning",
                            })
                            .then(() => {
                                auth.removeToken();
                                vueInstance.$router.push({ path: "/login" });
                                window.location.reload();
                            });
                        return Promise.reject();
                    } else {
                        return Promise.reject();
                    }
                }
            } catch {
                return Promise.reject();
            }
        }
    );

    this.post = (url, data, msg, isNoLoading) => {
        loadingMsg = msg;
        if (isNoLoading) {
            noLoading = true;
        } else {
            noLoading = false;
        }
        return this.instance.request({
            url: url,
            method: "POST",
            data: data,
        });
    };
    this.postFile = (url, data, msg) => {
        loadingMsg = msg;
        return this.instance.request({
            url: url,
            method: "POST",
            data: data,
            responseType: "blob",
        });
    };
    this.get = (url, msg) => {
        loadingMsg = msg;
        return this.instance.request({
            url: url,
            method: "GET",
        });
    };
};

const VueAjax = {
    post: () => {
        console.log(this);
    },
};
VueAjax.install = function (app) {
    app.mixin({
        beforeCreate() {
            if (!this.$root._rootAjax) {
                this.$root._rootAjax = new ajax(this.$root);
            }
            if (!this.$ajax) {
                this.$ajax = this.$root._rootAjax;
            }
        },
    });
};

export default VueAjax;
